import { SearchAdapter, SearchByIdRequest, SearchByIdResponse } from '@empathy/search-adapter';
import { container } from '../../../container';
import { DEPENDENCIES } from '../../../container/dependencies.const';
import { EmpathizeState, EmpathyXConfig, QueryOrigin } from '../../../models';
import { catchAdapterError } from '../../../utils';
import { GETTERS_KEYS } from '../../store.const';
import { EMPATHIZE_ACTIONS_KEYS, EMPATHIZE_MUTATIONS_KEYS } from '../empathize.const';
import { EmpathizeAction, EmpathizeContext } from '../empathize.interfaces';

export class GetIdentifierSuggestionsAction implements EmpathizeAction {
  actions = {
    [EMPATHIZE_ACTIONS_KEYS.getIdentifierSuggestions]:
      (empathizeContext: EmpathizeContext): any => {
        const { rootState, commit } = empathizeContext;
        if (rootState.core.inputQuery) {
          const platformAdapter = container.get<SearchAdapter>(DEPENDENCIES.Adapter);

          const identifierSuggestionsRequest = this.getRequest(empathizeContext);
          commit(EMPATHIZE_MUTATIONS_KEYS.setLoading, true);
          platformAdapter.searchById(identifierSuggestionsRequest)
            .then(({ results }: SearchByIdResponse) => {
              const empathizeState: Partial<EmpathizeState> = { identifierSuggestions: results };
              commit(EMPATHIZE_MUTATIONS_KEYS.saveEmpathizeResponse, empathizeState);
              commit(EMPATHIZE_MUTATIONS_KEYS.setLoading, false);
            }).catch(catchAdapterError('Identifier suggestions'));
        } else {
          commit(EMPATHIZE_MUTATIONS_KEYS.saveEmpathizeResponse, { identifierSuggestions: [] });
        }
      }
  };

  private getRequest({ rootState, rootGetters }: EmpathizeContext): SearchByIdRequest {
    const { identifierSuggestions }: EmpathyXConfig = rootGetters[GETTERS_KEYS.config.config];
    return {
      query: rootState.core.inputQuery,
      rows: identifierSuggestions.size,
      origin: QueryOrigin.empathizeReference
    };
  }
}
